import axios from 'axios';
import { Prediction } from './prediction';
import { Query } from './query';

export function predict(query: Query): Promise<Prediction> {
    return axios.post('/api/predict', query).then(resp => resp.data);
}
